var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "foot" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "foot-two" }, [
      _vm._v(
        "Copyright © 2026 北京西宝电子技术有限责任公司. All Rights Reserved. "
      ),
      _c(
        "span",
        { staticClass: "footer-link", on: { click: _vm.handleClick } },
        [_vm._v("京ICP备07039918号-2")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "foot-one" }, [
      _c("div", { staticClass: "foot-logo" }, [
        _c("a", { attrs: { href: "/" } }, [
          _c("img", {
            attrs: {
              src: "/images/foot/foot_logo.png",
              alt: "北京西宝电子技术有限责任公司",
            },
          }),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "foot-info" }, [
        _c("div", { staticClass: "foot-item-left" }, [
          _c("div", { staticClass: "foot-item" }, [
            _c("span", { staticClass: "foot-item-title" }, [
              _vm._v("联系地址："),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "foot-desc" }, [
              _vm._v(
                "\n              北京市海淀区学清路8号科技财富中心 B座308-309室\n            "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "foot-item" }, [
            _c("span", { staticClass: "foot-item-title" }, [_vm._v("传真：")]),
            _vm._v(" "),
            _c("div", { staticClass: "foot-desc" }, [
              _vm._v("\n              010 - 62316463\n            "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "foot-item" }, [
            _c("span", { staticClass: "foot-item-title" }, [
              _vm._v("联系电话："),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "foot-desc" }, [
              _vm._v("\n              010 - 62312909\n            "),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "foot-item" }, [
            _c("span", { staticClass: "foot-item-title" }, [_vm._v("邮箱：")]),
            _vm._v(" "),
            _c("div", { staticClass: "foot-desc" }, [
              _vm._v("\n              sales@beijingxibao.com\n            "),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "foot-item-right" }, [
          _c("img", {
            staticStyle: { width: "132px", height: "132px" },
            attrs: { src: "/images/footImg/wechat.png", alt: "微信" },
          }),
          _vm._v(" "),
          _c("img", {
            staticStyle: { width: "132px", height: "132px" },
            attrs: { src: "/images/footImg/xcx.png", alt: "微信" },
          }),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }